/**
 * Application entry point.
 *
 * Renders the app tree:
 *   <StrictMode> -> <AppProviders> -> <AppRouter>
 *
 * StrictMode is on for dev-time double-rendering checks. It's a no-op in
 * production builds.
 */
import { StrictMode } from "react";

import { createRoot } from "react-dom/client";

import { ErrorBoundary } from "@/app/ErrorBoundary";
import { AppProviders } from "@/app/providers/AppProviders";
import { AppRouter } from "@/app/router";

import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element not found. Check index.html.");
}

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ErrorBoundary>
  </StrictMode>,
);
